import { render, staticRenderFns } from "./BcNotesList.vue?vue&type=template&id=56be8fb8"
import script from "./BcNotesList.vue?vue&type=script&lang=js"
export * from "./BcNotesList.vue?vue&type=script&lang=js"
import style0 from "./BcNotesList.vue?vue&type=style&index=0&id=56be8fb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports